var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"conflict-solution"},[_c('div',{staticClass:"text"},_vm._l((_vm.diff),function(l,i){return _c('pre',{key:i,class:l.className},[_vm._v(_vm._s(l.line))])}),0),_vm._v(" "),_c('button',{on:{"click":function($event){return _vm.$emit('on-choose-solution')}}},[_vm._v("\n\t\t"+_vm._s(_vm.button)+"\n\t")])])
}
var staticRenderFns = []

export { render, staticRenderFns }